export const rootId = 'product-listing-root';
export const DEFAULT_SEARCH_TERM = 'constructorio';
export const DEFAULT_PRODUCTS_PER_PAGE = 30;
export const DEFAULT_SORT_OPTION = 'relevance';
export const MAX_PRODUCTS_PER_PAGE = 96;
